
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.889 13.849c2.56 5.031 6.684 9.138 11.716 11.716l3.911-3.911c.48-.48 1.191-.64 1.813-.427a20.271 20.271 0 006.347 1.013c.978 0 1.778.8 1.778 1.778v6.204c0 .978-.8 1.778-1.778 1.778C13.983 32 .454 18.471.454 1.778.454.8 1.254 0 2.232 0h6.222c.978 0 1.778.8 1.778 1.778 0 2.222.356 4.356 1.013 6.347a1.784 1.784 0 01-.444 1.813L6.89 13.849z"}})])
          )
        }
      }
    